import type { AreaRoutes } from "@/app/routes/hr/areaRoutes";
import { RequireCapability } from "@/app/session/RequireCapability";

/* Recruitment: openings, the pipeline board, candidates, interviews and scorecards, offers and
   hiring, under /hiring. The candidate's public offer page (/offer/:token) is in router.tsx.
   Every page answers 404 while recruitment is switched off. Openings, boards and applications
   are filtered by the server (a hiring manager sees theirs, an interviewer the applications they
   interview for), so only the candidate search also needs recruitment.view. */
export const recruitmentRoutes: AreaRoutes = {
  people: [],
  employee: [],
  me: [],
  top: [
    {
      element: <RequireCapability feature="recruitment" />,
      children: [
        {
          path: "hiring",
          lazy: async () => ({
            Component: (await import("@/features/recruitment/routes/HiringLayout")).default,
          }),
          children: [
            {
              index: true,
              lazy: async () => ({
                Component: (await import("@/features/recruitment/routes/OpeningsPage")).default,
              }),
            },
            {
              path: "interviews",
              lazy: async () => ({
                Component: (await import("@/features/recruitment/routes/MyInterviewsPage")).default,
              }),
            },
            {
              element: <RequireCapability permission="recruitment.view" />,
              children: [
                {
                  path: "candidates",
                  lazy: async () => ({
                    Component: (await import("@/features/recruitment/routes/CandidatesPage"))
                      .default,
                  }),
                },
              ],
            },
          ],
        },
        {
          path: "hiring/openings/:openingId",
          lazy: async () => ({
            Component: (await import("@/features/recruitment/routes/PipelinePage")).default,
          }),
        },
        {
          path: "hiring/applications/:applicationId",
          lazy: async () => ({
            Component: (await import("@/features/recruitment/routes/ApplicationPage")).default,
          }),
        },
      ],
    },
  ],
};
